import { state } from '../state.js';
import { $ } from '../utils/dom.js';
import { fmtMoney, fmtInt, escapeHtml } from '../utils/format.js';
import { montoDisplay } from '../utils/currency.js';

export function renderStatusTable() {
  const map = new Map();
  state.filtered.forEach((r) => {
    const k = r.STATUS || '(sin status)';
    if (!map.has(k)) map.set(k, { count: 0, total: 0 });
    const v = map.get(k);
    v.count++;
    v.total += montoDisplay(r);
  });
  const arr = [...map.entries()].sort((a, b) => b[1].count - a[1].count);
  const totalCount = state.filtered.length || 1;
  const t = $('statusTable');
  if (!arr.length) {
    t.innerHTML = `<tbody><tr><td class="empty">Sin resultados</td></tr></tbody>`;
    return;
  }
  t.innerHTML = `
    <thead><tr><th>Status</th><th class="num">Ventas</th><th class="num">%</th><th class="num">Monto</th></tr></thead>
    <tbody>${arr.map(([k, v]) => `
      <tr><td>${escapeHtml(k)}</td><td class="num">${fmtInt(v.count)}</td><td class="num">${(v.count / totalCount * 100).toFixed(1)}%</td><td class="num">${fmtMoney(v.total)}</td></tr>
    `).join('')}</tbody>`;
}
